import React from 'react';

import Types from '../../modules/types';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import {
  StoreLink,
} from '../../components/Links';

import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

const {
  STORE_TYPE_LABELS_MAP,
} = Types;

export const columnName = { path: 'name', sort: 'name', link: '/users/:_id' };

export const columnEmail = 'email';

export const columnRole = 'role';

export const columnActive = {
  path: 'active',
  title: 'Status',
  render: record => (record.active ? 'ACTIVE' : 'INACTIVE'),
};

export const columnStoreType = {
  path: 'storeType',
  render: record => STORE_TYPE_LABELS_MAP[record.storeType],
};

export const columnStore = {
  path: 'store',
  title: 'Store',
  render: (record, column, props) => (
    record.store
    ? (
        <StoreLink
          location={props.location}
          subject={record.store}
          pathname={getRoleBasedPath(props, '/orders')}
        />
      )
    : 'N/A'
  ),
};

export const ADMIN_ALL = [
  columnName,
  columnEmail,
  columnRole,
  columnActive,
  columnCreatedAt,
  columnUpdatedAt,
];

export const ADMIN_SELLERS = [
  columnName,
  columnEmail,
  columnActive,
  columnStoreType,
  columnStore,
  columnCreatedAt,
  columnUpdatedAt,
];
